import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MapsHomeWorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"maps_home_work"}/>
}
